// Двете DOM проверки, по които глобалният Esc (SharedAccountGate) и
// клавиатурата на работните листове решават „клавишът мой ли е". Живеят на
// ЕДНО място, за да разпознават отворен слой еднакво — копие би се разминало.

// Фокусът е в поле за писане — там Esc/буквите си са на полето.
export const isEditableTarget = (el: EventTarget | null) =>
  el instanceof HTMLElement &&
  (el.tagName === "INPUT" ||
    el.tagName === "TEXTAREA" ||
    el.tagName === "SELECT" ||
    el.isContentEditable);

// Отворен antd слой (модал/чекмедже/попъп) — Esc е негов (затваря го), не наш.
// Модалите остават в DOM и след затваряне (leave анимация / destroyOnClose),
// затова видимостта се гледа през computed display, не само по наличие.
export const hasOpenOverlay = () => {
  for (const el of document.querySelectorAll<HTMLElement>(
    ".ant-modal-wrap, .ant-image-preview-wrap",
  )) {
    if (getComputedStyle(el).display !== "none") return true;
  }
  return !!document.querySelector(
    ".ant-drawer-open, .ant-popover:not(.ant-popover-hidden), " +
      ".ant-dropdown:not(.ant-dropdown-hidden), .ant-select-open, " +
      ".ant-picker-dropdown:not(.ant-picker-dropdown-hidden)",
  );
};
